export const theme = config.VITE_THEME;
